import React, { useEffect, useMemo, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import * as Icon from 'ubs-icons';
import { COLOR, PLAN } from "ubs-framework/v2/common/constant";
import UAvatar from "ubs-framework/v2/UAvatar";
import { isElectron, isMobileDevice, notificationToast } from "ubs-framework/v2/common/function";
import UPopup from "ubs-framework/v2/UPopup";
import { getThumbor } from "../../common/common";
import ToolBar from "../toolbar";
import UAccountSidebar from "./components/account-sidebar";
import useSocket from "../../app-account/common/useSocket";
import { getKeyName } from "ubs-framework/v2/common/function";
import { sendData } from "../../store/actions";
import { planMerger } from 'ubs-framework/v2/common/function';
import { getCookie } from 'ubs-framework/v2/common/function';
import UAssignUser from '../../common/component/UAssignUser';
import { SIDEBAR_PRODUCT_LIST } from '../../common/product-config';
import { ORG_OVERVIEW_USER_IDS } from '../../common/constant';
import usePlan from '../../common/hooks/usePlan';

const PRODUCT_LIST = [
    { key: 'hrms', name: 'Super HRMS', Icon: Icon.HRMS, url: process.env.REACT_APP_HRMS_MODULE_URL, path: '/dashboard', roles: ['admin', 'member'] },
    { key: 'payroll', name: 'Super Payroll', Icon: Icon.PayrollLogo, url: process.env.REACT_APP_PAYROLL_MODULE_URL, path: '/', roles: ['admin', 'member'] },
    { key: 'pms', name: 'Super Project', Icon: Icon.PMS, url: process.env.REACT_APP_PMS_MODULE_URL, path: '/', roles: ['admin', 'member', 'client'] },
    { key: 'recruit', name: 'Super Recruit', Icon: Icon.ATSLogo, url: process.env.REACT_APP_RECRUIT_MODULE_URL, path: '/', roles: ['admin', 'member'] },
    { key: 'chat', name: 'Super Chat', Icon: Icon.UbsChat, url: process.env.REACT_APP_CHAT_MODULE_URL, path: '/', roles: ['admin', 'member'] },
    { key: 'survey', name: 'Super Survey', Icon: Icon.SurveyLogo, url: process.env.REACT_APP_SURVEY_MODULE_URL, path: '/', roles: ['admin', 'member'] },
    { key: 'assets', name: 'Super Asset', Icon: Icon.AssetsLogo, url: process.env.REACT_APP_ASSETS_MODULE_URL, path: '/', roles: ['admin', 'member'] },
    { key: 'performance', name: 'Super Performance', Icon: Icon.Performance, url: process.env.REACT_APP_PERFORMANCE_MODULE_URL, path: '/', roles: ['admin', 'member'] },
    { key: 'track', name: 'Super Track', Icon: Icon.SuperTrack, url: process.env.REACT_APP_TRACK_MODULE_URL, path: '/', roles: ['admin', 'member'] },
];

const SideMenuLayout = (props) => {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const __plan = usePlan();
    const _WI_HRMS = __plan(PLAN?.whatsappIntegration, 'and', 'hrms')
    const _WI_REC = __plan(PLAN?.whatsappIntegration, 'and', 'recruit')
    const _WI_PMS = __plan(PLAN?.whatsappIntegration, 'and', 'pms')
    const _WI_PAY = __plan(PLAN?.whatsappIntegration, 'and', 'payroll')
    const _AP_LINK = __plan(PLAN?.aadhaarPanLinkStatus, 'and', 'hrms')
    const _AP_VERIFY = __plan(PLAN?.aadhaarCardVerification, 'and', 'hrms')
    const _PAN_V = __plan(PLAN?.panCardVerification, 'and', 'hrms')
    
    const [innerListVisible, setInnerListVisible] = useState(false);
    const [selectedInnerItem, setSelectedInnerItem] = useState('');
    const [showOrgPopup, setShowOrgPopup] = useState(false);
    const [showProductPopup, setShowProductPopup] = useState(false);

    // Refs for outside click detection
    const eyeIconRef = useRef(null);
    const popupRef = useRef(null);
    const productBtnRef = useRef(null);
    const productPopupRef = useRef(null);

    // Wallet Billing (Phase 8) gate — bounded retry on transport error (max 2),
    // reset whenever the org changes.
    const gateRetryRef = useRef(0);
    const gateRetryTimeoutRef = useRef(null);

    const _C_ORG = useSelector(e => e.common.currentOrg);
    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL);
    const _ORG_ID = useSelector(e => e.common.orgId);
    const _ORG_LIST = useSelector(e => e.common.orgList);
    const _OSB = useSelector(e => e.common.openSidebar);
    const _PI = useSelector(e => e.common.planInfo);
    const _ID = useSelector(e => e?.common?._id);
    const _OWI = useSelector(e => e.common?.ownerId);
    const _ADMIN = useSelector(e => e.common?.isAdmin)
    const _UT = useSelector(e => {
        const userType = e?.common?.orgList?.find(_ => _?.orgId === e?.common?.orgId)?.userType
        return (userType?.hrms === 3 || userType?.recruit === 1 || userType?.pms === 3)
    });
    // Inactive Employee Login: a restricted session (current org marks the member in-window inactive)
    // has no access to other products, so hide the product switcher and Active Sessions from the
    // Account sidebar. Workspace stays visible. Per-org flag carried on currentOrg from getWorkspaceList.
    const _IIR = useSelector(e => e.common?.currentOrg?.isInactiveRestricted === true)
    // Wallet Billing (Phase 8) — null = not yet resolved (nav stays hidden, route stays open); true/false = resolved
    const _WALLET_GATE = useSelector(e => e.common?.walletBillingGate);
    const _BILLING_TABS = _WALLET_GATE?.tabs
        || (_WALLET_GATE?.hasAccess ? { wallet: true, history: true, invoices: true, receipts: true, reports: true } : {});

    const [active, setActive] = useState('workspace');
    const [innerRouteActive, setInnerRouteActive] = useState('');
    const [subMenuFlag, setSubMenuFlag] = useState(false);
    const [activeOrg, setActiveOrg] = useState("");
    const [orgList, setOrgList] = useState([]);

    // ESS / Non-ESS Policy modal state
    const [openEssPolicy, setOpenEssPolicy] = useState(false);
    const [essAssignData, setEssAssignData] = useState({ users: [], assignedUser: [], essCount: 0, nonEssCount: 0 });
    const [essAssignLoading, setEssAssignLoading] = useState(false);
    const [apiUsageAccess, setApiUsaageAccess] = useState(false)    

    const list = useMemo(() => [
        {
            icon: <Icon.NoTask />,
            name: 'Workspace',
            route: 'manage/workspace',
            include_route: true,
            isAccess: true,
        },
        // {
        //     icon: <Icon.User />,
        //     name: 'Ess/Non-Ess Policy',
        //    // route: 'manage/workspace',
        //     include_route: true,
        //     isAccess: (!!_C_ORG?.invoiceSetting?.isNonEssEnabled && _C_ORG?.isAdmin) ,
        //     essCount: essAssignData.essCount,
        //     nonEssCount: essAssignData.nonEssCount,
        // },
        {
            icon: <Icon.ChartData />,
            name: 'Organization Overview',
            route: 'manage/organization-overview',
            include_route: true,
            isAccess: !_IIR && ORG_OVERVIEW_USER_IDS.includes(_ID),
        },
        {
            icon: <Icon.Desktop />,
            name: 'Active Sessions',
            route: 'manage/active-sessions',
            include_route: true,
            isAccess: !_IIR,
        },
        {
            icon: <Icon.Report />,
            name: 'Active Sessions Report',
            route: 'manage/active-sessions-report',
            include_route: true,
            isAccess: _OWI === _ID || _UT,
        },
        {
            icon: <Icon.CreditCard />,
            name: 'API Usage Monitor',
            route: 'manage/api-usage-monitor',
            include_route: true,
            // Open to all account users like Active Sessions/Workspace — Account's currentOrg.uac
            // carries no hrms.report node, so HRMS's report-level UAC cannot be replicated here.
            isAccess: !_IIR && ((_OWI === _ID || apiUsageAccess) && (_WI_REC || _WI_HRMS || _AP_LINK || _AP_VERIFY || _PAN_V || _WI_PMS || _WI_PAY)),
        },
        {
            icon: <Icon.Diamond />,
            name: 'Pricing Plans',
            route: 'manage/pricing-plan',
            include_route: true,
            isAccess: !_IIR && _PI?.isTrialAccount && _OWI === _ID,
        },
        {
            icon: <Icon.CreditCard />,
            name: 'Subscriptions',
            route: 'manage/subscriptions',
            isAccess: !_IIR && _PI?.isTrialAccount && _OWI === _ID,
            include_route: false,
            inner_menu: [
                { main_route: 'manage/subscriptions', name: 'All Payments', route: 'payments', isAccess: _PI?.isTrialAccount && _OWI === _ID },
                { main_route: 'manage/subscriptions', name: 'Payment Methods', route: 'payment-method', isAccess: _PI?.isTrialAccount && _OWI === _ID },
                { main_route: 'manage/subscriptions', name: 'Activity', route: 'activity', isAccess: _PI?.isTrialAccount && _OWI === _ID },
            ]
        },
        {
            icon: <Icon.Wallet />,
            name: 'Billing',
            route: 'manage/billing',
            isAccess: !_IIR && !!_WALLET_GATE?.hasAccess
                && ['dashboard', 'wallet', 'history', 'invoices', 'receipts', 'reports', 'tdsClaim'].some(tab => !!_BILLING_TABS?.[tab]),
            include_route: false,
            inner_menu: [
                { main_route: 'manage/billing', name: 'Dashboard', route: 'dashboard', isAccess: !!_WALLET_GATE?.hasAccess && !!_BILLING_TABS?.dashboard },
                { main_route: 'manage/billing', name: 'Wallet', route: 'wallet', isAccess: !!_WALLET_GATE?.hasAccess && !!_BILLING_TABS?.wallet },
                { main_route: 'manage/billing', name: 'History', route: 'history', isAccess: !!_WALLET_GATE?.hasAccess && !!_BILLING_TABS?.history },
                { main_route: 'manage/billing', name: 'Invoices', route: 'invoices', isAccess: !!_WALLET_GATE?.hasAccess && !!_BILLING_TABS?.invoices },
                { main_route: 'manage/billing', name: 'Receipts', route: 'receipts', isAccess: !!_WALLET_GATE?.hasAccess && !!_BILLING_TABS?.receipts },
                { main_route: 'manage/billing', name: 'Reports', route: 'reports', isAccess: !!_WALLET_GATE?.hasAccess && !!_BILLING_TABS?.reports },
                { main_route: 'manage/billing', name: 'TDS Claim', route: 'tds-claim', isAccess: !!_WALLET_GATE?.hasAccess && !!_BILLING_TABS?.tdsClaim },
            ]
        },
    ], [_C_ORG, _PI, _OWI, _ID, _ADMIN, _UT, essAssignData, apiUsageAccess, _WI_HRMS, _WI_REC, _AP_LINK, _AP_VERIFY, _PAN_V, _WALLET_GATE, _WI_PMS, _WI_PAY, _IIR]);

    const { on, off, refresh } = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'getWorkspaceList': {
                    const activeOrgId = res?.data?.activeOrgId
                    const processedList = res?.data?.list?.map(e => {
                        e.planAccess = planMerger(e?.planAccess, e?.productAccess, e?.isAdmin)
                        return e
                    })
                    const userType = processedList?.find(_ => _?.orgId === activeOrgId)?.userType;
                    dispatch({ type: 'SET_ORG_LIST', payload: processedList })
                    dispatch({ type: 'SET_CURRENT_ORG', payload: activeOrgId ? processedList?.find(e => e?.orgId === activeOrgId) : processedList?.[0] })
                    setActiveOrg(activeOrgId)
                    setOrgList(processedList)
                    if (userType?.hrms === 3 || userType?.recruit === 1 || userType?.pms === 3) setApiUsaageAccess(true);
                    else setApiUsaageAccess(false)
                    break
                }
                case 'account|employee|essType|assignList': {
                    const essList = res?.data?.essList || [];     // ESS employees → right panel
                    const nonEssList = res?.data?.nonEssList || []; // Non-ESS employees → left panel
                    const essCount = res?.data?.essCount || 0;
                    const nonEssCount = res?.data?.nonEssCount || 0;
                    const allUsers = [...essList, ...nonEssList].map(u => ({
                        ...u,
                        _id: u.user,  // UAssignUser expects _id
                        name: `${u.firstName} ${u.lastName}`.trim(),
                    }));
                    setEssAssignData({
                        users: allUsers,
                        assignedUser: nonEssList.map(u => u.user), // Non-ESS = assigned (right side)
                        essCount,
                        nonEssCount
                    });
                    setEssAssignLoading(false);
                    break
                }
                case 'account|employee|essType|assign': {
                    if (res?.data?.success || !res?.error) {
                        notificationToast("success", "success", `${res?.data?.message}`);
                        setOpenEssPolicy(false);
                    }
                    setEssAssignLoading(false);
                    break
                }
                case 'account|employee|essType|history': {
                    setEssHistoryData(res?.data || {});
                    setEssHistoryLoading(false);
                    break
                }
                case 'billing|wallet|client|gate': {
                    gateRetryRef.current = 0;
                    dispatch({ type: 'SET_WALLET_BILLING_GATE', payload: res?.data?.result || { hasAccess: false, isOwner: false } });
                    break
                }
                default:
                    return true
            }
        } else if (res.event === 'billing|wallet|client|gate') {
            // Transport-level error (e.g. socket timeout) resolving the gate — retry a
            // bounded number of times. NEVER dispatch hasAccess:false here: the gate
            // stays null/unresolved so a legit deep-linked user's Billing route is never
            // 404'd, only the sidebar entry stays hidden until we resolve it.
            if (gateRetryRef.current < 2) {
                gateRetryRef.current += 1;
                gateRetryTimeoutRef.current = setTimeout(() => {
                    sendData(dispatch, 'billing|wallet|client|gate', {});
                }, 2000);
            }
        }
    })

    useEffect(() => {
        refresh();
        // if (_C_ORG?._id) {
        //     sendData(dispatch, 'account|employee|essType|assignList', { dbId: _C_ORG?._id });
        // }
        return () => off();
    }, [_C_ORG?._id])

    // Wallet Billing (Phase 8) — resolve access once per org; re-resolves on org switch.
    // Reset to null (unresolved) FIRST so the previous org's access never flashes the
    // Billing entry/section on a company that does not have it.
    useEffect(() => {
        if (_ORG_ID) {
            gateRetryRef.current = 0;
            dispatch({ type: 'SET_WALLET_BILLING_GATE', payload: null });
            sendData(dispatch, 'billing|wallet|client|gate', {});
        }
        return () => {
            if (gateRetryTimeoutRef.current) clearTimeout(gateRetryTimeoutRef.current);
        };
    }, [_ORG_ID]);

    const accessibleProducts = useMemo(() => {
        return SIDEBAR_PRODUCT_LIST.filter(product => {
            const hasAccess = _C_ORG?.planAccess?.[product.key]?.default?.access;
            const hasRole = product.roles.includes(_C_ORG?.role);
            const trackWorkDiary = (_C_ORG?.uac?.track?.myWorkDiary?.modules?.workDiary?.action?.read?.value || _C_ORG?.uac?.track?.employeeWorkDiary?.modules?.workDiary?.action?.read?.value)
            if (product.adminOnly && !_ADMIN) return false
            return hasAccess && hasRole && (product.key === 'track' ? trackWorkDiary : true);
        });
    }, [_C_ORG, _ADMIN]);

    // Handle click outside to close popups
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showOrgPopup &&
                popupRef.current &&
                !popupRef.current.contains(event.target) &&
                eyeIconRef.current &&
                !eyeIconRef.current.contains(event.target)) {
                setShowOrgPopup(false);
            }
            if (showProductPopup &&
                productPopupRef.current &&
                !productPopupRef.current.contains(event.target) &&
                productBtnRef.current &&
                !productBtnRef.current.contains(event.target)) {
                setShowProductPopup(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showOrgPopup, showProductPopup]);

    // Handle escape key to close popups
    useEffect(() => {
        const handleEscapeKey = (event) => {
            if (event.key === 'Escape') {
                if (showOrgPopup) setShowOrgPopup(false);
                if (showProductPopup) setShowProductPopup(false);
            }
        };

        document.addEventListener('keydown', handleEscapeKey);
        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, [showOrgPopup, showProductPopup]);

    useEffect(() => {
        const paths = location.pathname.split('/').filter(p => p);

        const mainRoute = paths[2] || 'workspace';
        const innerRoute = paths[3] || '';
        const fullRoute = `manage/${mainRoute}`;

        setActive(fullRoute);
        setInnerRouteActive(innerRoute);

        const currentMenuItem = list?.find(item => item?.route === fullRoute);

        if (currentMenuItem?.inner_menu && currentMenuItem.inner_menu.length > 0) {
            setSubMenuFlag(true);
            setInnerListVisible(true);
            setSelectedInnerItem(fullRoute);
        } else {
            setSubMenuFlag(false);
            setInnerListVisible(false);
            setSelectedInnerItem('');
        }
    }, [location.pathname]);
    // useEffect(() => {
    //     const paths = location.pathname.split('/').filter(p => p);
    //     const mainRoute = paths[1] || 'workspace';
    //     const innerRoute = paths[2] || '';
    //
    //     setActive(mainRoute);
    //     setInnerRouteActive(innerRoute);
    //
    //     const currentMenuItem = list.find(item => item.route === mainRoute);
    //
    //     if (currentMenuItem?.inner_menu && currentMenuItem.inner_menu.length > 0) {
    //         setSubMenuFlag(true);
    //         setInnerListVisible(true);
    //         setSelectedInnerItem(mainRoute);
    //     } else {
    //         setSubMenuFlag(false);
    //         setInnerListVisible(false);
    //         setSelectedInnerItem('');
    //     }
    // }, [location.pathname]);
    const toggleInnerList = (route) => {
        if (selectedInnerItem === route) {
            setInnerListVisible(!innerListVisible);
        } else {
            setInnerListVisible(true);
            setSelectedInnerItem(route);
        }
    };

    const toggleOrgPopup = () => {
        setShowOrgPopup(!showOrgPopup);
    };

    const handleOrgSwitch = (org) => {
        const url = `/${org?.orgId}/manage/workspace`;
        if (isElectron()) window.location.href = url;
        else window?.open(url, '_blank');
        setShowOrgPopup(false);
    };

    const toggleProductPopup = () => {
        setShowProductPopup(!showProductPopup);
    };

    const handleProductSwitch = (product) => {
        const token = getCookie('token');
        const url = `${product.url}${product.path}${token ? `?token=${token}` : ''}`;
        if (isElectron()) window.location.href = url;
        else window?.open(url, '_blank');
        setShowProductPopup(false);
    };

    // Menu click
    const menuChange = (param, i, e) => {
        // ESS/Non-Ess Policy — fetch employee list via socket and open modal
        if ('Ess/Non-Ess Policy'.includes(param?.name)) {
            setOpenEssPolicy(true);
            setEssAssignLoading(true);
            setEssAssignData({ users: [], assignedUser: [] });
            // sendData(dispatch, 'account|employee|essType|assignList', { dbId: _C_ORG?._id });
            return;
        }
        if (param?.inner_menu && param?.inner_menu?.length !== 0) {
            toggleInnerList(param.route);
            setSubMenuFlag(true);
            setActive(param.route);

            const firstChild = param?.inner_menu?.find(child => child?.isAccess);
            if (selectedInnerItem !== param.route && firstChild) {
                history.push(`/${_ORG_ID}/${param.route}/${firstChild.route}`);
                setInnerRouteActive(firstChild.route);
            }
        } else {
            const route = `/${_ORG_ID}/${param.route}`;
            history.push(route);
            setInnerRouteActive('');
            setInnerListVisible(false);
            setSubMenuFlag(false);
            setActive(param.route);
            hideSidebar()
        }
    };

    // Inner menu click
    const innerMenuChange = (e, param, route) => {
        e.stopPropagation();
        history.push(`/${_ORG_ID}/${route}/${param.route}`);
        setActive(route);
        setInnerRouteActive(param.route);
        hideSidebar()
    }

    const [essHistoryData, setEssHistoryData] = useState({});
    const [essHistoryLoading, setEssHistoryLoading] = useState(false);

    const checkLink = (e) => {
        dispatch({ type: 'OPEN_SIDEBAR', payload: false });
    }

    const hideSidebar = () => {
        dispatch({ type: 'OPEN_SIDEBAR', payload: false });
    }

    return (
        <React.Fragment>
            <div className="u_account-layout">
                {/* Sidebar Overlay for mobile */}
                {_OSB && <div className="u_left-sidebar-overlay" onClick={hideSidebar} />}

                {/* Sidebar */}
                <div className={`u_left-sidebar ${_OSB ? 'u_active' : ''}`}>
                    {/* Company header */}
                    <div className="u_left-sidebar-header">
                        <div className="u_left-sidebar-logo u_bb-light u_flex-align u_content-between u_org-switcher">
                            {_C_ORG?.company && <UPopup
                                params={{ className: "u_tooltip u_tooltip-full", disabled: isMobileDevice() }}
                                desc={<span>{_C_ORG?.company}</span>}
                            >
                                <div className="u_org-logo u_flex u_align-center u_cp">
                                    <UAvatar name={_C_ORG?.company} image={_C_ORG?.logoURL} s3Url={_S3_BASE_URL} thumbor={getThumbor()} width="36" />
                                    <p className="u_one-line u_org-name u_flex-1-0">{_C_ORG?.company}</p>
                                </div>
                            </UPopup>}

                            {/* Organization Switcher */}
                            {!isElectron() && <div className="u_mr-6">
                                {!!orgList?.length && <span
                                    className="u_eye-icon "
                                    onClick={toggleOrgPopup}
                                    ref={eyeIconRef}
                                >
                                    <div className="u_flex-align u_content-center u_width-24 u_h-24 u_radius-8 u_cp u_switch-btn">
                                        <Icon.ChevronsUpDown size={14} fill={'#73788b'} />
                                    </div>
                                </span>}

                                {/* Organization Popup */}
                                {showOrgPopup && (
                                    <div
                                        className="u_org-switcher-custom"
                                        ref={popupRef}
                                    >
                                        <div className="u_org-switcher-header">
                                            <h3>Switch Organizations</h3>
                                        </div>
                                        <div className="u_org-switcher-list">
                                            {orgList?.map(org => (
                                                <div
                                                    key={org.id}
                                                    className={`u_org-item ${(_ORG_ID === org?.orgId) ? 'u_current-org' : ''}`}
                                                    onClick={() => handleOrgSwitch(org)}
                                                >
                                                    <div>
                                                        <span className={`u_radio-icon ${(_ORG_ID === org?.orgId) ? 'u_active' : ''}`} />
                                                    </div>
                                                    <div className={"u_pl-8"}>
                                                        <UAvatar name={org.company} image={org.logoURL} s3Url={_S3_BASE_URL} thumbor={getThumbor()} width="36" />
                                                    </div>
                                                    <div className="u_org-info">
                                                        <p className="u_one-line u_org-name u_flex-1-0">{org.company}</p>
                                                    </div>
                                                    <div className="u_arrow">
                                                        <Icon.ArrowLeftLine fill="#007AFF" size={14} className="u_arrow-icon" />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>}
                        </div>
                    </div>

                    {/* Switch Product — hidden for a restricted (inactive) session (no other-product access) */}
                    {!_IIR && !isElectron() && accessibleProducts?.length > 0 && (
                        <div className="u_org-switcher u_mt-8 u_mx-8">
                            <div
                                className="u_flex-align u_content-between u_cp u_px-12 u_py-8 u_radius-8 u_b-light"
                                onClick={toggleProductPopup}
                                ref={productBtnRef}
                            >
                                <div className="u_flex-align">
                                    <Icon.GridView size={16} fill={COLOR.u_icon_bg} />
                                    <span className="u_small-font u_fw-600 u_color-title u_pl-8">Switch Product</span>
                                </div>
                                <div className="u_flex-align u_content-center u_width-24 u_h-24 u_radius-8 u_cp u_switch-btn">
                                    <Icon.ChevronsUpDown size={14} fill={'#73788b'} />
                                </div>
                            </div>

                            {showProductPopup && (
                                <div
                                    className="u_org-switcher-custom"
                                    ref={productPopupRef}
                                >
                                    <div className="u_org-switcher-header">
                                        <h3>Switch Product</h3>
                                    </div>
                                    <div className="u_org-switcher-list large">
                                        {accessibleProducts?.map(product => (
                                            <div
                                                key={product.key}
                                                className="u_org-item"
                                                onClick={() => handleProductSwitch(product)}
                                            >
                                                <div className='u_width-34 u_h-34 u_flex-align u_content-center u_b-light u_radius-4'>
                                                    <product.Icon size={20} fill={COLOR.u_blue} />
                                                </div>
                                                <div className="u_org-info">
                                                    <p className="u_one-line u_org-name u_flex-1-0">{product.name}</p>
                                                </div>
                                                <div className="u_arrow">
                                                    <Icon.ArrowLeftLine fill="#007AFF" size={14} className="u_arrow-icon" />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Sidebar Menu */}
                    <div className="u_left-sidebar-menubar">
                        <UAccountSidebar
                            list={list}
                            innerListVisible={innerListVisible}
                            setInnerListVisible={setInnerListVisible}
                            onClick={menuChange}
                            onInnerClick={innerMenuChange}
                            isOpen={true}
                            isSubMenu={subMenuFlag}
                            active={active}
                            inner_active={innerRouteActive}
                        />
                    </div>

                    {_PI?.isTrialAccount && _OWI === _ID && (
                        <div className="u_mx-8 u_mb-8">
                            <div className="u_bg-blue-1 u_radius-8 u_p-16 u_cp">
                                <div className="u_flex u_direction-column u_align-center">
                                    <div className="u_width-40 u_h-40 u_bg-white u_round-radius u_flex-align u_content-center u_mb-10">
                                        <Icon.Contact fill={COLOR.u_blue} size={20} />
                                    </div>
                                    <p className="u_font-14 u_fw-700 u_color-title u_mb-4">Need Help?</p>
                                    <p className="u_small-font u_color-font u_text-center u_mb-10">Our team is ready to assist you</p>
                                    <div className="u_w-full u_flex-align u_content-center u_bg-white u_radius-5 u_py-8 u_b-light"  onClick={() => window.open('https://superworks.com/contact-us/', '_blank')}>
                                        <Icon.Contact fill={COLOR.u_blue} size={14} className="u_mr-6" />
                                        <span className="u_small-font u_fw-600 u_color-blue">Contact Support</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className='u_flex-align u_content-center u_bt-light u_py-10 u_bg-thead'>
                        <a href="https://superworks.com" target="_blank">
                            <img src="/images/images/superworks-logo.png" height={35} className="u_cp" />
                        </a>
                    </div>
                </div>

                {/* Main Content */}
                <div className="u_content u_active">
                    <ToolBar />
                    {props.children}
                </div>
            </div>

            {/* ESS / Non-ESS Policy Assign Modal */}
            {openEssPolicy && (
                <UAssignUser    
                    header="Ess/Non-Ess Policy"
                    users={essAssignData?.users}
                    assignedUser={essAssignData?.assignedUser}
                    loading={essAssignLoading}
                    leftTitle="ESS Employee List"
                    rightTitle="Non ESS Employee List"
                    save={(data) => {
                        const { newAssign, removeAssign } = data;
                        if (newAssign?.length || removeAssign?.length) {
                            setEssAssignLoading(true);
                            if (newAssign?.length) {
                                sendData(dispatch, 'account|employee|essType|assign', {
                                    dbId: _C_ORG?._id,
                                    user: newAssign,
                                    isNonEss: true
                                });
                            }
                            if (removeAssign?.length) {
                                sendData(dispatch, 'account|employee|essType|assign', {
                                    dbId: _C_ORG?._id,
                                    user: removeAssign,
                                    isNonEss: false
                                });
                            }
                        } else {
                            setOpenEssPolicy(false);
                        }
                    }}
                    onSearch={(val) => {
                        sendData(dispatch, 'account|employee|essType|assignList', {
                            dbId: _C_ORG?._id,
                            search: val || ''
                        });
                    }}
                    onHistory={(filterParams) => {
                        setEssHistoryLoading(true);
                        sendData(dispatch, 'account|employee|essType|history', {
                            dbId: _C_ORG?._id,
                            ...filterParams
                        });
                    }}
                    historyData={essHistoryData}
                    historyLoading={essHistoryLoading}
                    close={() => setOpenEssPolicy(false)}
                />
            )}
        </React.Fragment>
    );
};

SideMenuLayout.defaultProps = {
    module: 'both',
}

export default SideMenuLayout;

